/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, MenuItem, RadioGroup, Radio, FormControlLabel, FormLabel, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton  } from "@mui/material";
import { typeLimits } from "../../util/DataObject";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const LimitsBalance = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState({ type: "", entity: {uuid: ""}, percentage_too: false });
  const [error, setErrors] = useState({ type: "", entity: "", percentage_too: "" });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    let d = { type: "", entity: {uuid: ""}, percentage_too: false };
    setForm(JSON.parse(JSON.stringify(d)));
    setDisabled(true);
  };

  
  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (field) {
      field === "entity" ? f[field]["uuid"] = e.target.value : f[field] = e.target.value
      if(field === "percentage_too"){
        e.target.value === "true" ? f[field] = true : f[field] = false
      } 
      !e.target.value ? er[field] = "Dato obligatorio" : er[field] = ""
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };
  
  const validateForm = (f, err) => {
    if (f["type"] && f["entity"]["uuid"] && !err["type"] && !err["entity"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  
  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = form;

    let request = await API.service( "limitsBalance", data, props.pos, props.changeAlert, props.changeLoader, history);
    if ( request.status === 200 && request.data.data.response === "OK") {
      let widg = request.data.data.widget;
      props.setWidgets(JSON.parse(JSON.stringify(widg)));
      props.updateNext("update");
      closelightbox();
    } else {
      let detail = request.data.data.message;
      props.setWidgets([]);
      props.changeAlert(true, "error", "Error al consultar límites, " + detail);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle style={{marginBottom: "0"}} >
          <span>
            Consultar Límites
            <p id="subtitle_2">Límites Transaccionales de Cuentas</p>
          </span>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={5}>
              <TextField
                label="Tipo de Límite" value={form.type || ""} onChange={changeValue.bind(this, "type")} error={error.type !== ""} helperText={error.type ? error.type : ''} select fullWidth size="small" >
                {typeLimits.map((i) => {
                  return (<MenuItem key={i.key} value={i.key}>{i.label}</MenuItem>);
                })}
              </TextField>
            </Grid>
            <Grid item xs={7} style={{display: "flex", justifyContent: "right"}}>
              <FormLabel component="legend" style={{width: "55%", fontSize:"14px", fontStyle: "italic"}}>¿Visualizar porcentaje consumido del limite?</FormLabel>
              <RadioGroup aria-label="position" row  value={form.percentage_too || false} onChange={changeValue.bind(this, "percentage_too")}>
                <FormControlLabel control={<Radio value={true} />} label="Si" />
                <FormControlLabel control={<Radio value={false} />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Identificador del Espacio" value={form.entity.uuid} onChange={changeValue.bind(this, "entity")} error={error.entity !== ""} helperText={error.entity ? error.entity : ''} size="small" fullWidth />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Consultar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default LimitsBalance;
